import $ from 'jquery';
import * as helpers from './helpers';
import {els, constants, breakpoints} from './variables';

function setMenuShoppingCartTotal() {
	const cartCount = $(".cartcontents");
	cartCount.text(cartCount.text().replace(" items", ""));

	const cartContents = $(".wpmenucart-contents");
	cartContents.wrapInner("<div class='wpmenucart-contents-inner'></div>");
}

function initMainMenu(e) {
	const menuItemsWithChildren = $(".main-menu .menu-item-has-children");

	// target sub-menus that appear offscreen and add the menu-item-last class
	menuItemsWithChildren.on('mouseenter mouseleave', function (e) {
		if ($('.sub-menu', this).length && els.viewport.width() > breakpoints.md) {
			var el = $('.sub-menu', this);
			var l = el.offset().left;
			var w = el.width();

			if (l + w >= els.viewport.width()) {
				$(this).addClass('menu-item-last');
			}
		}
	});

	const speed = 250;
	menuItemsWithChildren.find('> a').on('click', function(e) {
		if(els.viewport.width() < breakpoints.md) {
			const link = $(this);
			const item = link.parent('.menu-item');
			const parent = item.closest('.menu-item');
			const siblings = item.siblings('.open');

			if(!link.hasClass('clicked')) {
				link.addClass('clicked');

				if(item.is(parent)) {
					siblings.removeClass('open').find('> .sub-menu').slideUp(speed);
					siblings.find('a.clicked').removeClass('clicked');
					item.addClass('open').find('> .sub-menu').slideToggle(speed);
				}

				e.preventDefault();
			}
		}
	});

	$(document).on('click', '.main-menu .menu-item a', function(e) {
		const link = $(this);
		if(els.viewport.width() >= breakpoints.md) {
			if(!link.hasClass('clicked')) {
				link.addClass('clicked');
			} else {
				this.click();
			}
		}
	});

	$('.search-control').click(function() {
		const searchInput = els.header.find(".search-input");
		if(!searchInput.is(":focus")) {
			setTimeout(function(){
				searchInput.focus();
			}, 0);
		}
	});

	setMenuShoppingCartTotal();
}

function handleMainMenuOnResize(e) {

	if(els.viewport.width() >= breakpoints.md) {
		$("body").removeClass("menu-open");
		$("body").removeClass("search-open");
		$(".menu-item, .mob-menu, .menu-trigger, .search-trigger").removeClass("open");

		els.header.css({
			paddingTop: function() {
				return els.header.find('.utilities').height();
			}
		});

		$('.header-primary').height('auto');

		$('.main-menu .menu-item.open').removeClass('open');
		$('.main-menu .sub-menu').show();
		$('.main-menu .clicked').removeClass('clicked');
	} else {
		els.header.css({
			paddingTop: 0
		});

		$('.header-primary').height(function() {
			return els.viewport.height() - els.header.height();
		});

		$('.main-menu .sub-menu').each(function() {
			var subMenu = $(this);
			var parent = subMenu.parent();
			if(!parent.hasClass('open')) {
				subMenu.hide();
			}
		});
	}

	$(".main-menu > .menu-item-has-children > .sub-menu").each(function() {
		if($(this).height() > (els.viewport.height() - els.header.height())) {
			$(this).addClass("split-sub-menu");
		}
	});
};

window.addEventListener('DOMContentLoaded', initMainMenu);
window.addEventListener('resize', helpers.debounce(handleMainMenuOnResize));
